import flowRight from 'lodash/flowRight';
import React, { PureComponent } from "react";
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectCurOrg } from 'logic/orgs'

export const formatCurrency = {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'symbol',
};

export const hasValue = val => val && val !== 0;
export const calcPrice = (price, val, perc) => perc
  ? (parseInt(price, 10) * val / 10000)
  : val;

export const calcConcession = (price, concession) => {
  let res = parseInt(price, 10);
  if (hasValue(concession.get('sr'))) {
    res += calcPrice(price, concession.get('sr'), false);
  }
  if (hasValue(concession.get('cr'))) {
    res += calcPrice(price, concession.get('cr'), true);
  }
  concession.get('surcharges').forEach(surcharge => {
    res += calcPrice(price, surcharge.get('value'), surcharge.get('perc'));
  })
  return res;
}

export const calcTotal = ({ price, concession }) =>
  concession.get('hide_fees')
    ? price.get('value')
    : calcConcession(price.get('value'), concession)

class Currency extends PureComponent {

  render() {
    const { value, hideCurrency, org } = this.props;
    const opts = {
      ...formatCurrency,
      currency: org.currency,
    }
    if (hideCurrency) {
      opts.style = 'decimal';
      opts.currency = undefined;
      opts.currencyDisplay = undefined;
      opts.minimumFractionDigits = 2;
      opts.maximumFractionDigits = 2;
    }
    return (
      <FormattedNumber value={value / 100.0} {...opts} />
    );
  }
}


const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({}, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps)
);
export default enhance(Currency);
